"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (content, regex) => {
    return Boolean(content.match(regex));
};
